import React from 'react';
import { Logo } from './Logo';
import { Button } from './Button';
export function Navbar() {
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-39">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-40">
        <a href="#" className="focus:outline-none focus:ring-2 focus:ring-techblue rounded-sm" data-id="element-41">
          <Logo data-id="element-42" />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-id="element-43">
          <a href="#problema" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-44">
            Problema
          </a>
          <a href="#como-funciona" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-45">
            Cómo funciona
          </a>
          <a href="#para-quien" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-46">
            Para quién
          </a>
          <a href="#vision" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-47">
            Visión
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-48">
          <Button variant="ghost" className="hidden sm:inline-flex" data-id="element-49">
            Ver Ejemplo
          </Button>
          <Button variant="solid" data-id="element-50">Solicitar Demo</Button>
        </div>
      </div>
    </header>;
}